import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendarPlus} from '@fortawesome/pro-solid-svg-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canExpireAsset} from '../enablers/canExpireAsset';
import {AssetExpirationActionLabel} from '../locales';

export const assetExpirationActionExpireIcon = faCalendarPlus;

export type AssetExpirationActionExpireParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (asset: IAsset) => void;
};

/**
 * Expire asset
 * @param params
 * @returns Action
 */
export const assetExpirationActionExpire = (
	asset: IAsset,
	{cb, ...params}: AssetExpirationActionExpireParams,
): ReactAction => ({
	name: 'asset-expiration-expire',
	cb: () => cb(asset),
	enableTest: () => canExpireAsset(asset),
	icon: assetExpirationActionExpireIcon,
	get label() {
		return AssetExpirationActionLabel.EXPIRE;
	},
	...params,
});

export default assetExpirationActionExpire;
